import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { Link } from 'gatsby';
import { StaticImage } from 'gatsby-plugin-image';
import React from 'react';
import { TypeOcrH6 } from './Types';

export default function ConservationBannerPlatform() {
  return (
    <>
      <Box sx={{ width: '100%', my: 2 }}>
        <Stack
          direction={{ xs: 'column', sm: 'column', md: 'row', lg: 'row' }}
          justifyContent={{ xs: 'center', sm: 'center', md: 'space-evenly' }}
          alignItems={{ xs: 'center', md: 'space-evenly' }}
        >
          <Box
            sx={{
              height: '150',
              width: '150',
              m: 3,
              ml: 8,
            }}
          >
            <Box sx={{ m: 3, fit: 'scale-down' }}>
              <StaticImage
                src='https://cdn.shopify.com/s/files/1/0552/0923/0485/files/macaw-image.png?v=1658249266'
                alt='macaw recovery network logo'
              />
            </Box>
          </Box>
          <Stack alignItems='center' justifyContent='center'>
            <TypeOcrH6 mx={2}>Giving Back</TypeOcrH6>
            <Typography align='center' mx={2} mb={2}>
              Did you know that a portion of all sales at NE are donated to
              animal and environmental conservation? As members of 1% for the
              Planet, we commit to giving back. We have ongoing partnerships
              supporting bats, pangolins, amphibians, and parrots. Learn more on
              our <Link to='/pages/environment'>Sustainability page.</Link>
            </Typography>
          </Stack>
        </Stack>
      </Box>
    </>
  );
}
